/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { WidgetTextTemplate } from '../models/widget-text-template';
@Injectable({
  providedIn: 'root',
})
class WidgetTextTemplateService extends __BaseService {
  static readonly WidgetTextTemplateGetAllPath = '/api/WidgetTextTemplate/GetAll';
  static readonly WidgetTextTemplateGetPath = '/api/WidgetTextTemplate/Get/{id}';
  static readonly WidgetTextTemplateGetPreviewImagePath = '/api/WidgetTextTemplate/GetPreviewImage/{id}';
  static readonly WidgetTextTemplateCreatePath = '/api/WidgetTextTemplate/Create';
  static readonly WidgetTextTemplateUpdatePath = '/api/WidgetTextTemplate/Update/{id}';
  static readonly WidgetTextTemplateDeletePath = '/api/WidgetTextTemplate/Delete/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `WidgetTextTemplateService.WidgetTextTemplateGetAllParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `siteType`:
   *
   * - `isActive`:
   *
   * - `customerId`:
   *
   * - `category`:
   */
  WidgetTextTemplateGetAllResponse(params: WidgetTextTemplateService.WidgetTextTemplateGetAllParams): __Observable<__StrictHttpResponse<Array<WidgetTextTemplate>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.type != null) __params = __params.set('type', params.type.toString());
    if (params.siteType != null) __params = __params.set('siteType', params.siteType.toString());
    if (params.isActive != null) __params = __params.set('isActive', params.isActive.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    if (params.category != null) __params = __params.set('category', params.category.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/WidgetTextTemplate/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<WidgetTextTemplate>>;
      })
    );
  }
  /**
   * @param params The `WidgetTextTemplateService.WidgetTextTemplateGetAllParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `siteType`:
   *
   * - `isActive`:
   *
   * - `customerId`:
   *
   * - `category`:
   */
  WidgetTextTemplateGetAll(params: WidgetTextTemplateService.WidgetTextTemplateGetAllParams): __Observable<Array<WidgetTextTemplate>> {
    return this.WidgetTextTemplateGetAllResponse(params).pipe(
      __map(_r => _r.body as Array<WidgetTextTemplate>)
    );
  }

  /**
   * @param id undefined
   */
  WidgetTextTemplateGetResponse(id: number): __Observable<__StrictHttpResponse<WidgetTextTemplate>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/WidgetTextTemplate/Get/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WidgetTextTemplate>;
      })
    );
  }
  /**
   * @param id undefined
   */
  WidgetTextTemplateGet(id: number): __Observable<WidgetTextTemplate> {
    return this.WidgetTextTemplateGetResponse(id).pipe(
      __map(_r => _r.body as WidgetTextTemplate)
    );
  }

  /**
   * @param id undefined
   */
  WidgetTextTemplateGetPreviewImageResponse(id: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/WidgetTextTemplate/GetPreviewImage/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  WidgetTextTemplateGetPreviewImage(id: number): __Observable<Blob> {
    return this.WidgetTextTemplateGetPreviewImageResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `WidgetTextTemplateService.WidgetTextTemplateCreateParams` containing the following parameters:
   *
   * - `previewImage`:
   *
   * - `UpdatedAt`:
   *
   * - `Type`:
   *
   * - `SortOrder`:
   *
   * - `SiteType`:
   *
   * - `PreviewImageMimeType`:
   *
   * - `Name`:
   *
   * - `IsSystem`:
   *
   * - `IsActive`:
   *
   * - `Id`:
   *
   * - `Html`:
   *
   * - `HasPreviewImage`:
   *
   * - `Description`:
   *
   * - `CustomerId`:
   *
   * - `CreatedBy`:
   *
   * - `CreatedAt`:
   *
   * - `Category`:
   */
  WidgetTextTemplateCreateResponse(params: WidgetTextTemplateService.WidgetTextTemplateCreateParams): __Observable<__StrictHttpResponse<WidgetTextTemplate>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.previewImage != null) { __formData.append('previewImage', params.previewImage as unknown as string | Blob);}
    if (params.UpdatedAt != null) { __formData.append('UpdatedAt', params.UpdatedAt as unknown as string | Blob);}
    if (params.Type != null) { __formData.append('Type', params.Type as unknown as string | Blob);}
    if (params.SortOrder != null) { __formData.append('SortOrder', JSON.stringify(params.SortOrder));}
    if (params.SiteType != null) { __formData.append('SiteType', params.SiteType as unknown as string | Blob);}
    if (params.PreviewImageMimeType != null) { __formData.append('PreviewImageMimeType', params.PreviewImageMimeType as unknown as string | Blob);}
    if (params.Name != null) { __formData.append('Name', params.Name as unknown as string | Blob);}
    if (params.IsSystem != null) { __formData.append('IsSystem', JSON.stringify(params.IsSystem));}
    if (params.IsActive != null) { __formData.append('IsActive', JSON.stringify(params.IsActive));}
    if (params.Id != null) { __formData.append('Id', JSON.stringify(params.Id));}
    if (params.Html != null) { __formData.append('Html', params.Html as unknown as string | Blob);}
    if (params.HasPreviewImage != null) { __formData.append('HasPreviewImage', JSON.stringify(params.HasPreviewImage));}
    if (params.Description != null) { __formData.append('Description', params.Description as unknown as string | Blob);}
    if (params.CustomerId != null) { __formData.append('CustomerId', JSON.stringify(params.CustomerId));}
    if (params.CreatedBy != null) { __formData.append('CreatedBy', params.CreatedBy as unknown as string | Blob);}
    if (params.CreatedAt != null) { __formData.append('CreatedAt', params.CreatedAt as unknown as string | Blob);}
    if (params.Category != null) { __formData.append('Category', params.Category as unknown as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/WidgetTextTemplate/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WidgetTextTemplate>;
      })
    );
  }
  /**
   * @param params The `WidgetTextTemplateService.WidgetTextTemplateCreateParams` containing the following parameters:
   *
   * - `previewImage`:
   *
   * - `UpdatedAt`:
   *
   * - `Type`:
   *
   * - `SortOrder`:
   *
   * - `SiteType`:
   *
   * - `PreviewImageMimeType`:
   *
   * - `Name`:
   *
   * - `IsSystem`:
   *
   * - `IsActive`:
   *
   * - `Id`:
   *
   * - `Html`:
   *
   * - `HasPreviewImage`:
   *
   * - `Description`:
   *
   * - `CustomerId`:
   *
   * - `CreatedBy`:
   *
   * - `CreatedAt`:
   *
   * - `Category`:
   */
  WidgetTextTemplateCreate(params: WidgetTextTemplateService.WidgetTextTemplateCreateParams): __Observable<WidgetTextTemplate> {
    return this.WidgetTextTemplateCreateResponse(params).pipe(
      __map(_r => _r.body as WidgetTextTemplate)
    );
  }

  /**
   * @param params The `WidgetTextTemplateService.WidgetTextTemplateUpdateParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `previewImage`:
   *
   * - `UpdatedAt`:
   *
   * - `Type`:
   *
   * - `SortOrder`:
   *
   * - `SiteType`:
   *
   * - `PreviewImageMimeType`:
   *
   * - `Name`:
   *
   * - `IsSystem`:
   *
   * - `IsActive`:
   *
   * - `Id`:
   *
   * - `Html`:
   *
   * - `HasPreviewImage`:
   *
   * - `Description`:
   *
   * - `CustomerId`:
   *
   * - `CreatedBy`:
   *
   * - `CreatedAt`:
   *
   * - `Category`:
   */
  WidgetTextTemplateUpdateResponse(params: WidgetTextTemplateService.WidgetTextTemplateUpdateParams): __Observable<__StrictHttpResponse<WidgetTextTemplate>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;

    if (params.previewImage != null) { __formData.append('previewImage', params.previewImage as unknown as string | Blob);}
    if (params.UpdatedAt != null) { __formData.append('UpdatedAt', params.UpdatedAt as unknown as string | Blob);}
    if (params.Type != null) { __formData.append('Type', params.Type as unknown as string | Blob);}
    if (params.SortOrder != null) { __formData.append('SortOrder', JSON.stringify(params.SortOrder));}
    if (params.SiteType != null) { __formData.append('SiteType', params.SiteType as unknown as string | Blob);}
    if (params.PreviewImageMimeType != null) { __formData.append('PreviewImageMimeType', params.PreviewImageMimeType as unknown as string | Blob);}
    if (params.Name != null) { __formData.append('Name', params.Name as unknown as string | Blob);}
    if (params.IsSystem != null) { __formData.append('IsSystem', JSON.stringify(params.IsSystem));}
    if (params.IsActive != null) { __formData.append('IsActive', JSON.stringify(params.IsActive));}
    if (params.Id != null) { __formData.append('Id', JSON.stringify(params.Id));}
    if (params.Html != null) { __formData.append('Html', params.Html as unknown as string | Blob);}
    if (params.HasPreviewImage != null) { __formData.append('HasPreviewImage', JSON.stringify(params.HasPreviewImage));}
    if (params.Description != null) { __formData.append('Description', params.Description as unknown as string | Blob);}
    if (params.CustomerId != null) { __formData.append('CustomerId', JSON.stringify(params.CustomerId));}
    if (params.CreatedBy != null) { __formData.append('CreatedBy', params.CreatedBy as unknown as string | Blob);}
    if (params.CreatedAt != null) { __formData.append('CreatedAt', params.CreatedAt as unknown as string | Blob);}
    if (params.Category != null) { __formData.append('Category', params.Category as unknown as string | Blob);}
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/WidgetTextTemplate/Update/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WidgetTextTemplate>;
      })
    );
  }
  /**
   * @param params The `WidgetTextTemplateService.WidgetTextTemplateUpdateParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `previewImage`:
   *
   * - `UpdatedAt`:
   *
   * - `Type`:
   *
   * - `SortOrder`:
   *
   * - `SiteType`:
   *
   * - `PreviewImageMimeType`:
   *
   * - `Name`:
   *
   * - `IsSystem`:
   *
   * - `IsActive`:
   *
   * - `Id`:
   *
   * - `Html`:
   *
   * - `HasPreviewImage`:
   *
   * - `Description`:
   *
   * - `CustomerId`:
   *
   * - `CreatedBy`:
   *
   * - `CreatedAt`:
   *
   * - `Category`:
   */
  WidgetTextTemplateUpdate(params: WidgetTextTemplateService.WidgetTextTemplateUpdateParams): __Observable<WidgetTextTemplate> {
    return this.WidgetTextTemplateUpdateResponse(params).pipe(
      __map(_r => _r.body as WidgetTextTemplate)
    );
  }

  /**
   * @param id undefined
   */
  WidgetTextTemplateDeleteResponse(id: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/WidgetTextTemplate/Delete/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  WidgetTextTemplateDelete(id: number): __Observable<Blob> {
    return this.WidgetTextTemplateDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module WidgetTextTemplateService {

  /**
   * Parameters for WidgetTextTemplateGetAll
   */
  export interface WidgetTextTemplateGetAllParams {
    type?: null | 0 | 1;
    siteType?: null | string;
    isActive?: null | boolean;
    customerId?: null | number;
    category?: null | string;
  }

  /**
   * Parameters for WidgetTextTemplateCreate
   */
  export interface WidgetTextTemplateCreateParams {
    previewImage?: null | Blob;
    UpdatedAt?: string;
    Type?: 0 | 1;
    SortOrder?: number;
    SiteType?: null | string;
    PreviewImageMimeType?: null | string;
    Name?: null | string;
    IsSystem?: boolean;
    IsActive?: boolean;
    Id?: number;
    Html?: null | string;
    HasPreviewImage?: boolean;
    Description?: null | string;
    CustomerId?: null | number;
    CreatedBy?: null | string;
    CreatedAt?: string;
    Category?: null | string;
  }

  /**
   * Parameters for WidgetTextTemplateUpdate
   */
  export interface WidgetTextTemplateUpdateParams {
    id: number;
    previewImage?: null | Blob;
    UpdatedAt?: string;
    Type?: 0 | 1;
    SortOrder?: number;
    SiteType?: null | string;
    PreviewImageMimeType?: null | string;
    Name?: null | string;
    IsSystem?: boolean;
    IsActive?: boolean;
    Id?: number;
    Html?: null | string;
    HasPreviewImage?: boolean;
    Description?: null | string;
    CustomerId?: null | number;
    CreatedBy?: null | string;
    CreatedAt?: string;
    Category?: null | string;
  }
}

export { WidgetTextTemplateService }
